export default "__VITE_ASSET__BbYQC9Yb__"